import React from 'react';
import { Table } from 'react-bootstrap';
import THead from "./components/THead";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import { sortArray } from "../../../../Utils";
import { calculateECost } from "../../prepareReport";

const DaysTable = ({ reportObj, countries, device, sortParam, sortOrder, onSortChange }) => {
    const { report, days } = reportObj;
    const rowsData = getRowsData(report, days, countries, device);
    const total = calcTotal(rowsData, days);

    if(sortParam) sortArray(rowsData, sortParam, sortOrder);

    const rows = rowsData.map(row => <Row {...row} days={days} key={`${row.country}:${row.device}`}/>);

    return (
        <Table bordered responsive>
            <THead days={days} onSortChange={onSortChange}/>
            <tbody>
                <TotalRow data={total} days={days} />
                {rows}
            </tbody>
        </Table>
    )
};

function calcTotal(data, days) {
    const totals = data.reduce((obj, { daysData }) => {
        days.forEach(day => {
            const dayData = daysData[day];

            if(!obj[day]) obj[day] = { spends: 0, conversions: 0 };

            if(dayData.spends) obj[day].spends += dayData.spends;
            if(dayData.conversions) obj[day].conversions += dayData.conversions;
        });

        return obj;
    }, {});

    Object.keys(totals).forEach(day => totals[day].eCost = calculateECost(totals[day].spends, totals[day].conversions));

    return totals;
}

function getRowsData(report, days, countries, selectedDevice) {
    return report.reduce((arr, { country, device, daysData }) => {
        let isMatchFilters = true;

        if(countries.length && countries.indexOf(country) === -1) isMatchFilters = false;
        else if(selectedDevice && selectedDevice !== device) isMatchFilters = false;

        if(isMatchFilters) {
            arr.push({ country, device, daysData: getDayData(daysData,days) });
        }

        return arr;
    }, []);
}

function getDayData(data, days) {
    return days.reduce((obj, day) => {
        obj[day] = getValues(data[day]);

        return obj;
    }, {});
}

function getValues(data) {
    let spends = 0, conversions = 0, eCost = 0;
    if(data) {
        if(data.spends) spends = data.spends;
        if(data.conversions) conversions = data.conversions;
        if(data.eCost) eCost = data.eCost;
    }

    return { spends, conversions, eCost };
}

export default DaysTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/DaysTable/index.js